import { useState, useRef, useEffect } from 'react';

/*
  Note: animationDurationMs is tied to the duration in the CSS here:
  web-wedding/src/components/onboard/OnboardSharedStyles.module.less:48
  It shouldn't be overwritten unless you are using a custom animation
*/

const useAnimation = (
  animationDelayMs = 0,
  animationDurationMs = 500
): {
  showMsg: boolean;
  isAnimating: boolean;
  onAnimationFinish: (cb: () => void) => void;
  clearAnimation: () => void;
} => {
  const delayTimer = useRef<number>();
  const animationTimer = useRef<number>();

  const [showMsg, setShowMsg] = useState(false);
  const [isAnimating, setIsAnimating] = useState(false);

  const onDelayFinish = (cb: () => void): void => {
    setIsAnimating(true);
    animationTimer.current = window.setTimeout(() => {
      cb();
      setIsAnimating(false);
    }, animationDurationMs);
  };

  const onAnimationFinish = (cb: () => void): void => {
    setShowMsg(true);
    delayTimer.current = window.setTimeout(() => {
      onDelayFinish(cb);
    }, animationDelayMs);
  };

  const clearAnimation = (): void => {
    clearTimeout(delayTimer.current);
    clearTimeout(animationTimer.current);
  };

  useEffect(() => clearAnimation(), []);

  return { showMsg, isAnimating, onAnimationFinish, clearAnimation };
};

export default useAnimation;
